<template>
  <div>
    <h3 class="text-lg leading-6 font-medium text-gray-900">Delivery Statistics</h3>
    <dl class="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-3">
      <BaseCard v-for="statistic in statistics" :key="statistic.name">
        <BaseCardBody>
          <dt class="text-sm font-medium text-gray-500 truncate">
            {{ statistic.label }}
          </dt>
          <dd class="mt-1 text-3xl font-semibold text-gray-900">
            {{ statistic.value }}
          </dd>
        </BaseCardBody>
      </BaseCard>
    </dl>
  </div>
</template>

<script>
import Numbro from '@/utils/numbro';

export default {
  props: {
    smsCampaign: {
      type: Object,
      required: true,
    },
  },
  computed: {
    statistics() {
      const formatAsThousands = (value) => Numbro(value || 0).format({ thousandSeparated: true });

      const formatAsCurrency = (value) =>
        Numbro(value || 0).formatCurrency({ mantissa: 3, spaceSeparated: true });

      return [
        {
          name: 'recipients_count',
          label: 'Total recipients',
          format: formatAsThousands,
        },
        {
          name: 'sms_messages_count',
          label: 'Total messages',
          format: formatAsThousands,
        },
        {
          name: 'total_cost',
          label: 'Total cost',
          format: formatAsCurrency,
        },
        {
          name: 'avg_cost_per_recipient',
          label: 'Average cost per recipient',
          format: formatAsCurrency,
        },
        {
          name: 'accepted_count',
          label: 'Accepted',
          format: formatAsThousands,
        },
        {
          name: 'buffered_count',
          label: 'Buffered',
          format: formatAsThousands,
        },
        {
          name: 'delivered_count',
          label: 'Delivered',
          format: formatAsThousands,
        },
        {
          name: 'expired_count',
          label: 'Expired',
          format: formatAsThousands,
        },
        {
          name: 'failed_count',
          label: 'Failed',
          format: formatAsThousands,
        },
        {
          name: 'rejected_count',
          label: 'Rejected',
          format: formatAsThousands,
        },
        {
          name: 'unknown_count',
          label: 'Unknmown',
          format: formatAsThousands,
        },
      ].map(({ name, label, format }) => ({
        name,
        label,
        value: format(this.smsCampaign?.statistics?.[name] || 0),
      }));
    },
  },
};
</script>
